import { Component, ContentChild, Input, TemplateRef } from '@angular/core';

@Component({
    selector: 'app-dock-content',
    templateUrl: './dock-content.component.html',
    styleUrls: ['./dock-content.component.scss']
})
export class DockContentComponent {
    
    /** TitleText */
    @Input() TitleText?: string | undefined;

    /** User template */
    @ContentChild(TemplateRef) itemTemplate?: TemplateRef<any>;

    /** Nav Template */
    @ContentChild('navbar', { read: TemplateRef }) navTpl!: TemplateRef<any>;

    /** Footer Template */
    @ContentChild('content', { read: TemplateRef }) contentTpl!: TemplateRef<any>;

    /** Footer Template */
    @ContentChild('footer', { read: TemplateRef }) footerTpl!: TemplateRef<any>;

    get hasNavBar(): boolean {
        return !!this.navTpl;
    }

    get hasContent(): boolean {
        return !!this.contentTpl;
    }

    get hasFooter(): boolean {
        return !!this.footerTpl;
    }

    /** New Notification */
    public NewNotification: boolean;
    
}
